// @flow
import * as React from 'react';

type SubscriptProps = {|
  children: React.Node,
|};

export const Subscript = ({children}: SubscriptProps) => <sub>{children}</sub>;
